import React from "react";
import Pagination from "@mui/material/Pagination";

const Table = ({ header, product, onRowClick, loading, currentPage, onPageChange, className = "" }) => {
  const rowsPerPage = 20;

  // Calculate the indices for the rows to display
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = product.slice(indexOfFirstRow, indexOfLastRow);

  // Calculate total pages
  const totalPages = Math.ceil(product.length / rowsPerPage);

  // Handle page change
  const handlePageChange = (event, newPage) => {
    onPageChange(newPage);
  };

  // Filter headers to include only active columns
  const activeHeaders = header.filter((item) => item.active);

  return (
    <div className="w-100">
      <div className="tbConatiner w-100 d-flex flex-column justify-content-start align-items-start overflow-auto">
        <table className={`premium-table ${className}`} style={{ width: "100%" }}>
          <thead className="position-sticky top-0 z-2">
            <tr>
              {activeHeaders.map((item, index) => (
                <th key={index}>
                  {item.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((item, index) => (
              <tr
                key={index}
                style={{
                  cursor: "pointer",
                  ...item.rowStyle,
                }}
                onClick={() => onRowClick && onRowClick(item)}
              >
                {activeHeaders.map((headerItem, key) => (
                  <td key={key}>{item[headerItem.name]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination and Entries Info */}
      <div className="empFooter w-100 d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap-reverse mt-4">
        <div
          style={{ minHeight: "50px", color: "var(--text-muted)", fontSize: '13px', fontWeight: '500' }}
          className="showText d-flex align-items-center mb-0"
        >
          {loading ? (
            <span className="placeholder-glow w-100">
              <span className="placeholder col-12"></span>
            </span>
          ) : (
            `Showing ${(currentPage - 1) * rowsPerPage + 1} to ${Math.min(
              currentPage * rowsPerPage,
              product.length
            )} of ${product.length} entries`
          )}
        </div>
        {loading ? (
          <span
            className="placeholder-glow"
            style={{ width: "200px" }}
          >
            <span
              className="placeholder col-12"
              style={{ height: "32px", borderRadius: '8px' }}
            ></span>
          </span>
        ) : (
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            size="medium"
            className="modern-pagination"
            sx={{
              "& .MuiPaginationItem-root": {
                fontWeight: 600,
                borderRadius: '8px',
              },
              "& .Mui-selected": {
                backgroundColor: 'var(--primary-color) !important',
                color: 'white',
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Table;